import { ReactNode } from 'react';
import Popover, { PopoverPlacement, PopoverProps } from '@idui/react-popover';
import classNames from 'classnames';
import Icon from 'components/atoms/Icon';
import { IconName } from 'components/atoms/Icon/all';
import { useIsMobile } from 'utils/hooks';

export interface HelpPopoverProps extends PopoverProps {
  headerText?: string | ReactNode;
  text?: string | ReactNode;
  headerIcon?: IconName;
  helpSubText?: string | ReactNode;
  disabled?: boolean;
  inline?: boolean;
  flex?: boolean;
  size?: number;
  icon?: IconName;
  iconClassName?: string;
  isTip?: boolean;
  arrowColor?: string;
  arrowSize?: number;
  className?: string;
  popoverClassName?: string;
  maxWidth?: string;
  placement?: PopoverPlacement;
  fitMaxWidthToBounds?: boolean;
  mobilePlacement?: PopoverPlacement;
}

function HelpPopover({
  content,
  children,
  helpSubText,
  disabled,
  inline,
  flex,
  size,
  icon,
  iconClassName,
  isTip,
  arrowColor,
  arrowSize,
  mouseLeaveDelay,
  className,
  popoverClassName,
  placement,
  fitMaxWidthToBounds = false,
  mobilePlacement,
  ...rest
}: HelpPopoverProps) {
  const isMobile = useIsMobile();
  return (
    <>
      <Popover
        className={classNames('!bg-glooCharcoal rounded-sm p-3 min-w-20 text-center', popoverClassName)}
        maxWidth="24rem"
        arrowColor={arrowColor ?? '#262524'}
        arrowSize={arrowSize ?? 12}
        isOpen={disabled ? false : undefined}
        mouseLeaveDelay={mouseLeaveDelay ?? 500}
        fitMaxWidthToBounds={isMobile ? true : fitMaxWidthToBounds}
        content={
          <div className={classNames('flex flex-1 flex-col text-sm', '!text-white')}>
            <>{content}</>
            {helpSubText && (
              <>
                <div className="border-glooGrayBorder w-full my-2" style={{ borderBottomWidth: '0.5px' }} />
                <div className={classNames('text-xs italic')}>{helpSubText}</div>
              </>
            )}
          </div>
        }
        {...rest}
        placement={isMobile ? mobilePlacement || PopoverPlacement.leftTop : placement}
      >
        <div
          className={classNames(
            'cursor-pointer',
            {
              'inline-block': inline,
              'flex flex-1 items-center justify-center': flex,
              block: !flex && !inline,
            },
            className,
          )}
        >
          <>
            {children || (
              <Icon
                name={icon || (isTip ? 'zap' : 'help-circle')}
                size={size || 18}
                className={classNames({ 'text-glooCharcoal': !isTip, 'text-yellow': isTip }, iconClassName)}
              />
            )}
          </>
        </div>
      </Popover>
    </>
  );
}

export default HelpPopover;
